import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {BACKEND_URL} from '@aztrix/environment';
import {PropertyType} from '@aztrix/models';
import {BehaviorSubject, map} from 'rxjs';

import {AbstractPropertyValueViewComponent} from '../abstract-property-value-view.component';

@Component({
  selector: 'ax-file-value-view',
  templateUrl: './file-value-view.component.html',
  styleUrls: ['./file-value-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileValueViewComponent extends AbstractPropertyValueViewComponent {
  source$ = this._backendUrl$.pipe(
    map((backendUrl) => backendUrl + '/staticFiles/agreementFiles/' + this.key)
  );

  constructor(@Inject(BACKEND_URL) private _backendUrl$: BehaviorSubject<string>) {
    super();
  }

  get key() {
    return this.propertyOfType(PropertyType.FILE_KEY)?.value;
  }

  get name() {
    return this.propertyOfType(PropertyType.FILE_NAME)?.value;
  }
}
